import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import trustedFormConfig from '../../Data/Maps/trustedFormConfig';
import { isHiddenTrustedFormQuestionPresentOnThisForm } from './trustedFormLoader.helpers';
import { parseSessionDataAndPopulateFormFields } from '../../Hooks/useBrowserMessages/useBrowserMessagesHelpers';
import { addConsentCertificationRecord } from '../../Lib/redux/slices/trustedForm';

const TrustedFormLoader = () => {
  const components = useSelector((store) => store.components);
  const dispatch = useDispatch();
  const { iFrameId } = useSelector((store) => store.optionalFormConfig);
  const { countryCode, formId } = useSelector((store) => store.formConfig);
  const { consentCertification } = useSelector((store) => store.trustedForm);
  const [trustedFormLoaded, setTrustedFormLoaded] = useState(false);

  useEffect(() => {
    if (trustedFormLoaded === false) {
      /*
       * Step 1 of 2 - Load and mount trusted form script into embedded Chameleon app DOM
       */
      const field = 'xxTrustedFormCertUrl';
      const documentProtocol =
        document.location.protocol === 'https:' ? 'https' : 'http';
      const tf = document.createElement('script');
      tf.type = 'text/javascript';
      tf.async = true;
      tf.src =
        // eslint-disable-next-line prefer-template
        documentProtocol +
        '://api.trustedform.com/trustedform.js?field=' +
        escape(field) +
        '&l=' +
        new Date().getTime() +
        Math.random();
      const s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(tf, s);
      setTrustedFormLoaded(true);

      window.trustedFormCertIdCallback = (embeddedCertificateId) => {
        /*
         *  Step 2 of 2 - Assign the embedded page's trusted form cert to the
         *                store's trusted form HTML input component value
         */

        // eslint-disable-next-line prefer-const
        setTimeout(() => {
          // eslint-disable-next-line no-console
          console.log(
            'MVF Info - Trusted Form Cert ID assigned from within form embed: ',
            embeddedCertificateId
          );

          if (
            isHiddenTrustedFormQuestionPresentOnThisForm(components, [
              trustedFormConfig.mappedAdmiralQuestionId,
              trustedFormConfig.questionText,
            ])
          ) {
            parseSessionDataAndPopulateFormFields({
              sessionData: { 'Trusted Form': embeddedCertificateId },
              components,
              dispatch,
              iFrameId,
              countryCode,
              formId,
            });
          }

          const consentCertificationRecord = {
            provider: 'trustedForm',
            location: 'form',
            id: embeddedCertificateId,
          };

          const consentCertificationAlreadyExists = consentCertification.some(
            (existingConsentCertificationRecord) => {
              return (
                existingConsentCertificationRecord.id === embeddedCertificateId
              );
            }
          );

          if (!consentCertificationAlreadyExists) {
            dispatch(
              addConsentCertificationRecord({
                consentCertificationRecord,
              })
            );
          }
        }, 1000);
      };
    }
  }, [trustedFormLoaded, consentCertification]);
  return null;
};

export default TrustedFormLoader;
